export const AzureContainerBlob = async (container, file) => {
    try {

        // Get the SAS token
        const sasToken = await getSasToken(container, file);

        const blobUrl = `https://aricareerssaprd.blob.core.windows.net/${container}/${file}?`;
        const urlWithSas = `${blobUrl}${sasToken}`;

        // Fetch the job data from the blob storage
        const response = await fetch(urlWithSas);
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }

        const data = await response.json();
        return data;  
    } catch (error) {
        console.error("Data load problem:", error);
        throw error;  
    }


};

//Need to handle this header key more efficently  
async function getSasToken(container, blob) {
    const response = await fetch(`https://ari-careers-fn-prd.azurewebsites.net/api/HttpTrigger1?container=${container}&blob=${blob}`, {
        method: 'GET',
        headers: {
            'x-functions-key': 'uWNb3c3lc2P-fR8gaFVzGghY9h8rquCLm6UDpJ1ZUx4AAzFuX1j-vQ=='
        }
    });
    const data = await response.json();
    return data.sasToken;  
}